var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9219 22.75C6.00187 22.75 1.17188 17.93 1.17188 12C1.17188 6.07 6.00187 1.25 11.9219 1.25C17.8419 1.25 22.6719 6.07 22.6719 12C22.6719 17.93 17.8519 22.75 11.9219 22.75ZM11.9219 2.75C6.82188 2.75 2.67188 6.9 2.67188 12C2.67188 17.1 6.82188 21.25 11.9219 21.25C17.0219 21.25 21.1719 17.1 21.1719 12C21.1719 6.9 17.0219 2.75 11.9219 2.75Z",
    fill: "#713FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9219 12.75H7.92188C7.51188 12.75 7.17188 12.41 7.17188 12C7.17188 11.59 7.51188 11.25 7.92188 11.25H15.9219C16.3319 11.25 16.6719 11.59 16.6719 12C16.6719 12.41 16.3419 12.75 15.9219 12.75Z",
    fill: "#713FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusRound);
export default __webpack_public_path__ + "static/media/minus-round.75e66430.svg";
export { ForwardRef as ReactComponent };